import React, { useState, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { Tabs } from 'antd';
import PermissionGuard from '../../components/PermissionGuard';
import { Modules } from '../../constants/permissions';
import { usePunchClock } from './hooks/usePunchClock';
import { useAttendanceHistory } from './hooks/useAttendanceHistory';
import KioskPanel from './components/KioskPanel';
import AttendanceTab from './components/AttendanceTab';
import PunchLogTab from './components/PunchLogTab';
import './PW9220Form.css';

const PW9220Form: React.FC = () => {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState('kiosk');

  // Punch clock hook
  const {
    logCode,
    modeLabel,
    employeeName,
    statusMessage,
    loading: punchLoading,
    flashBig,
    switchMode,
    punch,
  } = usePunchClock();

  // Attendance history hook
  const {
    attendanceList,
    punchLogs,
    attendanceTotal,
    punchLogTotal,
    loading: historyLoading,
    loadAttendance,
    loadPunchLogs,
  } = useAttendanceHistory();

  const handleExit = useCallback(() => {
    navigate('/erp');
  }, [navigate]);

  const tabItems = [
    {
      key: 'kiosk',
      label: '打卡',
      children: (
        <KioskPanel
          logCode={logCode}
          modeLabel={modeLabel}
          employeeName={employeeName}
          statusMessage={statusMessage}
          loading={punchLoading}
          flashBig={flashBig}
          onSwitchMode={switchMode}
          onPunch={punch}
          onExit={handleExit}
        />
      ),
    },
    {
      key: 'attendance',
      label: '出勤彙總',
      children: (
        <AttendanceTab
          attendanceList={attendanceList}
          attendanceTotal={attendanceTotal}
          loading={historyLoading}
          onLoad={loadAttendance}
        />
      ),
    },
    {
      key: 'punchLog',
      label: '打卡明細',
      children: (
        <PunchLogTab
          punchLogs={punchLogs}
          punchLogTotal={punchLogTotal}
          loading={historyLoading}
          onLoad={loadPunchLogs}
        />
      ),
    },
  ];

  return (
    <PermissionGuard module={Modules.CLOCK_INOUT || 'pw9220f1'}>
      <div className="pw9220-form">
        <div className="page-wrapper">
          <h2 className="page-title">簽到/退作業</h2>
          <Tabs
            activeKey={activeTab}
            onChange={setActiveTab}
            items={tabItems}
          />
        </div>
      </div>
    </PermissionGuard>
  );
};

export default PW9220Form;
